export class STORAGE_KEYS {
  public static readonly TOKEN_KEY = 'TOKEN';
  public static readonly REFRESH_TOKEN_KEY = 'REFRESH_TOKEN';
  public static readonly USER_ROLES = 'USER_ROLES';
  public static readonly TOKEN_EXPIRATION_KEY = 'TOKEN_EXPIRATION';
  // path to local medias [{incidentId:string, [{ mediaId: string, localMediaPath:string }]}]
  public static readonly LOCAL_MEDIAS_KEY = 'LOCAL_MEDIAS';
  public static readonly ACTIVE_SITE_KEY = 'ACTIVE_SITE';
  public static readonly ATTACHMENTS_SAS_URIS = 'ATTACHMENTS_SAS_URIS';
  public static readonly OPSQLITE_ENCRYPTION_KEY = 'OPSQLITE_ENCRYPTION_KEY';
  public static readonly EMAIL = 'EMAIL';
}

export class METADATA_KEYS {
  public static readonly PROJECT_NAME = 'projectName';
  public static readonly TITLE = 'Title';
  public static readonly DUEDATE = 'DueDate';
  public static readonly DUETIME = 'DueTime';
  public static readonly EQUIPMENTID = 'EquipmentId';
  public static readonly WORKERID = 'WorkerId';
  public static readonly DISMISS_REASON = 'DismissReason';
  public static readonly EXPIRY_DATE = 'ExpiryDate';
  public static readonly TRAINING_TYPE = 'TrainingType';
  public static readonly TRAINING_TYPE_ID = 'TrainingTypeId';
  public static readonly PROJECT = 'Project';
  public static readonly POTENTIAL_SEVERITY = 'PotentialSeverity';
  public static readonly INCIDENTDATE = 'IncidentDate';
  public static readonly INCIDENTTIME = 'IncidentTime';
  public static readonly PERSON_INVOLVED = 'PersonInvolved';
  public static readonly FIRST_AID_ATTENDANT = 'FirstAidAttendant';
  public static readonly ASSIGNED_TO = 'AssignedTo';
  public static readonly INVESTIGATION_REQUIRED = 'InvestigationRequired';
  public static readonly HAS_INVESTIGATION = 'HasInvestigation';
  public static readonly INVESTIGATION_CLOSED = 'InvestigationClosed';
  public static readonly LEAD_INVESTIGATOR = 'LeadInvestigator';
  public static readonly SUPERVISOR = 'Supervisor';
  public static readonly COMPLETED_BY = 'CompletedBy';
  public static readonly EMPLOYER = 'Employer';
}

export class COMMON_TEMPLATES {
  public static readonly TASK = 'Create a Task';
  public static readonly COMPLETE_TASK = 'Task';
  public static readonly TRAINING = 'Add A Training Record / Certification';
  public static readonly MEETING_MINUTES = 'Meeting Minutes';
  public static readonly SITE_INSPECTION = 'Site Inspection';
  public static readonly FIRST_AID_ASSESSMENT = 'First aid assessment';
}

export class TRAINING_TYPES {
  public static readonly TRAINING = 'training';
  public static readonly CERTIFICATE = 'certificate';
}

//Should match mongo permissions table
export class PERMISSIONS {
  //Supervisor Permission
  //Supervisor can manage reports of people they supervise
  public static readonly SUPERVISOR = 'SUPERVISOR';

  //Project Manager Permission
  //Project Manager can manage reports on the projects they manage
  //aka Safety manager/ Safety Admin
  public static readonly PROJECT_MANAGER = 'PROJECT_MANAGER';

  //Company Profile
  public static readonly COMPANY_PROFILE_UPDATE = 'COMPANY_PROFILE_UPDATE';

  //Document View
  public static readonly DOCUMENT_VIEW = 'DOCUMENT_VIEW'; //Can view all documents
  public static readonly DOCUMENT_EDIT = 'DOCUMENT_EDIT'; //Can delete/edit all documents

  //Permissions for Submission Bundles
  public static readonly BUNDLE_EXTERNAL_SUBMISSION =
    'BUNDLE_EXTERNAL_SUBMISSION';
  public static readonly BUNDLE_VIEW = 'BUNDLE_VIEW';

  //Task Permissions
  public static readonly TASK_VIEW = 'TASK_VIEW';

  //Permissions for report tab
  public static readonly REPORT_CREATE = 'REPORT_CREATE';
  public static readonly REPORT_UPDATE = 'REPORT_UPDATE'; //Can still update reports you create without this permission
  public static readonly REPORT_VIEW = 'REPORT_VIEW'; //Can still view reports you create without this permission
  public static readonly REPORT_ELEVATE = 'REPORT_ELEVATE';
  public static readonly REPORT_DELETE = 'REPORT_DELETE'; //Can still delete draft reports you create without this permission
  public static readonly REPORT_INVESTIGATION = 'REPORT_INVESTIGATION'; //Can create an investigation

  //Permissions for people tab
  public static readonly REPORT_PEOPLE_CREATE = 'REPORT_PEOPLE_CREATE';
  public static readonly REPORT_PEOPLE_UPDATE = 'REPORT_PEOPLE_UPDATE';
  public static readonly REPORT_PEOPLE_VIEW = 'REPORT_PEOPLE_VIEW';
  public static readonly REPORT_PEOPLE_DELETE = 'REPORT_PEOPLE_DELETE';

  //Permissions for operation tab
  public static readonly REPORT_OPERATION_CREATE = 'REPORT_OPERATION_CREATE';
  public static readonly REPORT_OPERATION_UPDATE = 'REPORT_OPERATION_UPDATE';
  public static readonly REPORT_OPERATION_VIEW = 'REPORT_OPERATION_VIEW';
  public static readonly REPORT_OPERATION_DELETE = 'REPORT_OPERATION_DELETE';

  //Permissions for equipment tab
  public static readonly REPORT_EQUIPMENT_CREATE = 'REPORT_EQUIPMENT_CREATE';
  public static readonly REPORT_EQUIPMENT_UPDATE = 'REPORT_EQUIPMENT_UPDATE';
  public static readonly REPORT_EQUIPMENT_VIEW = 'REPORT_EQUIPMENT_VIEW';
  public static readonly REPORT_EQUIPMENT_DELETE = 'REPORT_EQUIPMENT_DELETE';

  //Permissions for people list
  public static readonly PEOPLE_CREATE = 'PEOPLE_CREATE';
  public static readonly PEOPLE_UPDATE = 'PEOPLE_UPDATE';
  public static readonly PEOPLE_ACCESS = 'PEOPLE_ACCESS';
  public static readonly PEOPLE_CREATE_TRAINING = 'PEOPLE_CREATE_TRAINING';

  //Permissions for project list
  public static readonly PROJECT_CREATE = 'PROJECT_CREATE';
  public static readonly PROJECT_UPDATE = 'PROJECT_UPDATE';

  //Permissions for list management
  public static readonly LISTMANAGEMENT_UPSERT = 'LISTMANAGEMENT_UPSERT';

  //Permissions for lock and unlock
  public static readonly SUBMISSION_LOCK = 'SUBMISSION_LOCK';
  public static readonly SUBMISSION_UNLOCK = 'SUBMISSION_UNLOCK';
}

export class CATEGORY {
  public static readonly HOME = 'HOME';
  public static readonly REPORTS = 'REPORTS';
  public static readonly PEOPLE = 'PEOPLE';
  public static readonly OPERATIONS = 'OPERATIONS';
  public static readonly EQUIPMENT = 'EQUIPMENT';
  public static readonly INVESTIGATION = 'INVESTIGATION';
  public static readonly QUICKADD = 'QUICKADD';
}

export class PERSON_STATUSES {
  public static readonly ACTIVE = 'Active';
  public static readonly ACCESS = 'Access';
  public static readonly PENDING = 'Pending';
  public static readonly DISABLED = 'Disabled';
  public static readonly DEACTIVED = 'Deactivated';
}

export class FORM_TYPE {
  public static readonly SUBMISSION = 'Submission';
  public static readonly SUBMISSIONTRAINING = 'SubmissionTraining';
}

export class RELATION_TYPE {
  public static readonly PERSON_INVOLVED = 'PersonInvolved';
  public static readonly USER_INVOLVED = 'UserInvolved';
  public static readonly PROJECT = 'Project';
}

export class REALM_FUNCTION_NAMES {
  public static readonly GET_SYNC_MAX_DHV_BY_ORG = 'getSyncMaxDHVByOrg';
}

//Constant for defaulting values on dynamic forms
export class DEFAULT_SOURCE_KEY {
  //Default company data
  public static readonly COMPANYNAME = 'CompanyName';
  public static readonly TRADENAME = 'CompanyTradeName';
  public static readonly COMPANYOWNER = 'CompanyOwner';
  public static readonly MAILADDRESS = 'MailAddress';
  public static readonly STREETADDRESS = 'StreetAddress';
  public static readonly PRIMARYCONTACT = 'PrimaryContact';
  public static readonly WSBCNUMBER = 'WSBCNumber';
  public static readonly CORNUMBER = 'CORNumber';
  public static readonly SAFENUMBER = 'SAFENumber';
  public static readonly MAINACTIVITIES = 'MainActivities';
  public static readonly WSBCUNITS = 'WSBCUnits';
  public static readonly SAFETYCONTACT = 'SafetyContact';
  public static readonly AUDITCONTACT = 'AuditContact';

  //Used for training submissions
  //Set to current user if they're basic
  public static readonly TRAINEE = 'Trainee';
}

export const TRAINING_STATUSES = [
  'Valid',
  'Expiring Soon',
  'Expired',
  'Never Expires',
];

export class DOCUMENT_LIBRARY {
  public static readonly DEFAULT_STORAGE_SPACE = 500;
}

export class LOCK_STATUS {
  public static readonly LOCK = 'Lock';
  public static readonly UNLOCK = 'Unlock';
  public static readonly SUPERLOCK = 'Superlock';
}

export class OIICS_LINKS {
  public static readonly BODYPARTS =
    'https://wwwn.cdc.gov/wisards/oiics/Trees/MultiTree.aspx?TreeType=BodyPart';
  public static readonly NATURES =
    'https://wwwn.cdc.gov/wisards/oiics/Trees/MultiTree.aspx?TreeType=Nature';
  public static readonly MECHANISMS =
    'https://wwwn.cdc.gov/wisards/oiics/Trees/MultiTree.aspx?TreeType=Event';
  public static readonly SOURCES =
    'https://wwwn.cdc.gov/wisards/oiics/Trees/MultiTree.aspx?TreeType=Source';
}

export class ROLES {
  public static readonly FIRS_BASIC = 'FIRS Basic';
  public static readonly FIRS_ADMIN = 'FIRS Admin';
  public static readonly IMPERSONATOR_USER = 'Impersonator User';
  public static readonly PROJECT_SAFETY_MANAGER = 'Project/Safety Manager';
  public static readonly FIRS_SUPERVISOR = 'FIRS Supervisor';
  public static readonly SAFETY_ADMIN = 'Safety Admin';
}
